import Link from 'next/link'
import { style } from './Breadcrumbs.style'

type Props = {
  lists: {
    name: string
    path?: string
  }[]
}

const BreadCrumb = ({ lists }: Props) => {
  return (
    <ol aria-label="breadcrumb" css={style.nav}>
      {lists.map(({ name = 'HOME', path = '/' }, index) => (
        <li key={index}>
          {lists.length - 1 !== index ? (
            <Link href={path}>{name}</Link>
          ) : (
            <span aria-current="page">{name}</span>
          )}
        </li>
      ))}
    </ol>
  )
}
export default BreadCrumb
